import mapboxgl from 'mapbox-gl';
import maplibregl from 'maplibre-gl';

export default {
    methods: {
        openParcelMap(parcel) {
            this.triggerEventGA('click_parcel', {
                id: parcel.id,
                title: parcel.title
            });
            const params = new URLSearchParams(window.location.search);
            let parcelLink = !params ? parcel.display_link : parcel.display_link + '?' + params.toString();
            window.location.replace(parcelLink);
        },
        addParcelMarkers(parcelList) {
            const template = this.$refs['parcelMarkerTemplate'];
            if (!template) return;

            for (let i = 0; i < parcelList.length; i++) {
                const parcel = parcelList[i];
                const parcelId = `parcelMarker-${parcel.id}`;
                const existParcelMarker = document.getElementById(parcelId);

                if (!this.isShowParcelMaker(parcel)) {
                    if (existParcelMarker) {
                        existParcelMarker.remove();
                    }
                    continue;
                }

                if (!parcel.illustration_image_id) {
                    if (existParcelMarker) {
                        continue;
                    }
                }

                const divParcelMarker = template.cloneNode(true);
                divParcelMarker.querySelector('img').src = parcel.image_url;
                divParcelMarker.querySelector('.parcel-title').innerText = parcel.title;
                divParcelMarker.addEventListener('click', () => this.openParcelMap(parcel));

                if (parcel.illustration_image_id) {
                    if (existParcelMarker) {
                        existParcelMarker.remove();
                    }
                    divParcelMarker.querySelector('.parcel-title').style.display = 'none';
                    var markerParcel = divParcelMarker.querySelector('div');
                    divParcelMarker.style.display = 'none';
                    this.mySmartMap.on('render', () => {
                        var myImage = new Image();
                        myImage.src = parcel.illustration_image ? parcel.illustration_image.image_url : '';
                        var imageElement = divParcelMarker.querySelector('img');
                        var currentVal = this.mySmartMap.getZoom();
                        var routeName = window.location.pathname.split('/')[3];
                        var originalZoomLevel = routeName == 'parcels' ? this.parcelResource.zoom_level : this.mapData.zoom_level;
                        var perOfWidth = parcel.illustration_image ? parcel.illustration_image.width_size/100 : 1;
                        var spanWidth = myImage.width ? myImage.width * perOfWidth : 48;
                        var spanHeight = myImage.height ? myImage.height * perOfWidth : 48;
                        var scale = Math.pow(2, (currentVal - originalZoomLevel));
                        markerParcel.classList.remove('mask', 'mask-squircle', 'bg-base-100', 'h-14', 'w-14', 'p-1', 'marker-p');
                        divParcelMarker.classList.add('illustration-marker','parcel-marker');
                        imageElement.classList.remove('mask', 'mask-squircle', 'w-full', 'h-full', 'object-cover');
                        imageElement.style.cssText = parcel.illustration_image ? `${parcel.illustration_image.custom_style_css}` : '';
                        imageElement.src = parcel.illustration_image ? `${parcel.illustration_image.image_url}` : '';
                        imageElement.style.width = spanWidth * scale + 'px';
                        imageElement.style.height = spanHeight * scale + 'px';
                        divParcelMarker.style.transform = `rotate(${this.bearing}deg)`;
                        divParcelMarker.style.display = '';
                    });
                }

                const markerElement = document.createElement('div');
                markerElement.id = parcelId;
                markerElement.appendChild(divParcelMarker);


                if (this.useMaplibre) {
                    var marker = new maplibregl.Marker(markerElement).setLngLat(parcel.coordinates).addTo(this.mySmartMap)
                } else {
                    var marker = new mapboxgl.Marker(markerElement).setLngLat(parcel.coordinates).addTo(this.mySmartMap);
                }
                if (parcel.illustration_image_id) {
                    marker.setRotation(-this.mySmartMap.getBearing());
                }
            }
        }
    }
}
